import Vue from 'vue'
import Router from 'vue-router'

// import ArticleView from '@/components/ArticleView'
import defaultScene from '@/scenes/defaultScene'
import pageScene from '@/scenes/pageScene'
// import productScene from '@/scenes/productScene'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'defaultScene',
      component: defaultScene,
      props: { page: 'index' }
    },
    {
      path: '/:page',
      name: 'pageScene',
      component: pageScene,
      props: true
    }
    // {
    //   path: '/courses/:id', // courses should be based on every available product type here
    //   name: 'productScene',
    //   component: productScene,
    //   props: true // should @page be set here? is undefined now
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js